import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/sections/HeroSection";
import LogoMarquee from "../components/sections/LogoMarquee";
import FeaturesSection from "../components/sections/FeaturesSection";
import HowItWorksSection from "../components/sections/HowItWorksSection";
import ContentTypesSection from "../components/sections/ContentTypesSection";
import TestimonialsSection from "../components/sections/TestimonialsSection";
import PricingSection from "../components/sections/PricingSection";
import FAQSection from "../components/sections/FAQSection";
import CTASection from "../components/sections/CTASection";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      <main>
        <HeroSection />
        <LogoMarquee />
        <FeaturesSection />
        <HowItWorksSection />
        <ContentTypesSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
